<article class="export-notification" [class.export-notification--new]="notification.isNew" (click)="onItemClick()"
    role="button" tabindex="0" (keydown.enter)="onItemClick()" (keydown.space)="$event.preventDefault(); onItemClick()">
    <div class="export-notification__icon" aria-hidden="true">
        <mat-icon>file_download</mat-icon>
    </div>

    <div class="export-notification__body">
        <div class="export-notification__header">
            <h4 class="export-notification__title">
                {{ "notification." + messageKey | translate }}
            </h4>
            @if (notification.isNew) {
            <span class="export-notification__badge">
                {{ "notification.new" | translate }}
            </span>
            }
        </div>

        <p class="export-notification__report">
            {{ "notification." + reportType | translate }}
        </p>

        <div class="export-notification__footer">
            <time class="export-notification__time">
                {{ notification.receivedAt | date: "short" }}
            </time>
            <span class="export-notification__hint">
                {{ "notification.export_open_report" | translate }}
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </div>
    </div>

    <button mat-icon-button type="button" class="export-notification__dismiss" (click)="onDelete($event)"
        [matTooltip]="'notification.delete_notification' | translate"
        [attr.aria-label]="'notification.delete_notification' | translate">
        <mat-icon>close</mat-icon>
    </button>
</article>